import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { setSnackbarEnqueue } from 'utils/snackbar';

/**
 * Component that initializes the snackbar utility for use outside React components.
 * This should be rendered inside the SnackbarProvider.
 */
const SnackbarInitializer = () => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setSnackbarEnqueue(enqueueSnackbar);
  }, [enqueueSnackbar]);

  return null;
};

export default SnackbarInitializer;

